export default __webpack_public_path__ + "static/media/TemplateVendedoresBudgetForecast.fc10c043.xlsx";